// ABOUTME: Eventos de uso con Firebase Analytics (Google Analytics). Solo eventos anónimos con
// ABOUTME: parámetros de catálogo; nunca imágenes ni datos personales.
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent, setUserId, type Analytics } from "firebase/analytics";
import { deviceId } from "./api";

const config = {
  apiKey: "AIzaSyA3TQTosLX2UitTHeAoGWNdnxjCvuJSMhE",
  authDomain: "dreadlove-tryon.firebaseapp.com",
  projectId: "dreadlove-tryon",
  storageBucket: "dreadlove-tryon.firebasestorage.app",
  messagingSenderId: "623425657396",
  appId: "1:623425657396:web:ac1303bd2491e300ab8861",
  measurementId: "G-B3G19X8TK5",
};

let analytics: Promise<Analytics | null> | null = null;

function instance(): Promise<Analytics | null> {
  if (!analytics) {
    analytics = isSupported()
      .then((ok) => {
        if (!ok) return null;
        const a = getAnalytics(initializeApp(config));
        // El mismo identificador de dispositivo que va a Firestore: permite cruzar embudo y calidad.
        setUserId(a, deviceId());
        return a;
      })
      .catch(() => null);
  }
  return analytics;
}

export type EventParams = Record<string, string | number | boolean | undefined>;

/** Registra un evento; nunca lanza ni bloquea la interfaz. */
export function track(name: string, params: EventParams = {}): void {
  void instance().then((a) => {
    if (a) logEvent(a, name, params);
  });
}

const seen = new Set<string>();

/** Como `track`, pero una sola vez por carga de página: para «llegó al paso», no «hizo algo en el paso». */
export function trackOnce(name: string, params: EventParams = {}): void {
  const key = `${name}:${JSON.stringify(params)}`;
  if (seen.has(key)) return;
  seen.add(key);
  track(name, params);
}
